import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import {
  Box,
  ClickAwayListener,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
  withStyles
} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { white } from 'common/colors';
import styles from './styles';
import PropTypes from 'prop-types';

const ContentDocument = props => {
  const { classes, content, setError, docType = '' } = props;
  const [openTooltip, setOpenTooltip] = React.useState(false);

  const handleOpenTooltip = () => {
    setOpenTooltip(true);
  };

  const handleCloseTooltip = () => {
    setOpenTooltip(false);
  };

  const isNewStyleDoc = type => {
    const typeNew = ['DTRP', 'DTRPC', 'DSKL', 'DOCSP'];
    return typeNew.includes(type);
  };

  const getTooltip = () => {
    const data = content?.find(item => item.textType === 'TOOLTIP');
    return (
      <ClickAwayListener onClickAway={handleCloseTooltip}>
        <Tooltip
          PopperProps={{
            disablePortal: false
          }}
          arrow
          onClose={handleCloseTooltip}
          open={openTooltip}
          placement="top"
          title={data.text}
        >
          <button
            type="button"
            onClick={handleOpenTooltip}
            style={{
              background: 'transparent',
              border: 'none',
              padding: 0,
              margin: 0,
              cursor: 'pointer'
            }}
          >
            <img
              alt="tooltip-icon"
              src="/images/assets/tooltip-white-icon.svg"
            />
          </button>
        </Tooltip>
      </ClickAwayListener>
    );
  };

  const getTextTable = item => {
    let cellContainer;
    let cellClassName;

    if (item.table.style === 'outline') {
      cellClassName = classes.tableCellOutlined;
    } else if (item.table.style === 'noOutline') {
      cellClassName = classes.tableCellNoOutlined;
    } else {
      cellClassName = classes.tableCell;
    }

    if (item.table.style === 'outline') {
      cellContainer = classes.tableOutlined;
    } else if (item.table.style === 'noOutline') {
      cellContainer = classes.tableNoOutlined;
    } else {
      cellContainer = classes.tableContainer;
    }

    if (isNewStyleDoc(docType)) {
      const styleTable = item?.table?.style;
      return (
        <>
          {item.text && (
            <p
              className={
                styleTable === 'noOutline'
                  ? classes.titleTableBold
                  : classes.titleTable
              }
              style={{
                marginLeft: item.indentLevel + 'vh'
              }}
            >
              {item.srlNumber !== 'NULL' && <b>{item.srlNumber}. </b>}
              {item.text}
            </p>
          )}
          <TableContainer className={cellContainer}>
            <Table aria-label="customized table">
              <TableBody>
                {item.table.title && (
                  <TableRow>
                    <TableCell
                      colSpan={2}
                      style={{
                        backgroundColor: item.table.title.color,
                        padding: '8px'
                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{
                          color: item.table.title.colorText,
                          fontWeight: 700
                        }}
                      >
                        {item.table.title.text}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
                {React.Children.toArray(
                  item.table.rows.map(row => {
                    return (
                      <TableRow
                        key={row.label}
                        style={{
                          backgroundColor: row.color ? row.color : white
                        }}
                      >
                        <TableCell align="left" className={cellClassName}>
                          <Grid container direction="row" spacing={1}>
                            <Grid item>
                              <Typography
                                style={{
                                  color: row.colorText ? row.colorText : '',
                                  fontWeight: row.fontWeight
                                    ? row.fontWeight
                                    : ''
                                }}
                                variant="h6"
                              >
                                {row.label}
                              </Typography>
                              {row.caption && (
                                <Typography
                                  style={{
                                    color: row.colorText ? row.colorText : '',
                                    fontWeight: row.fontWeight
                                      ? row.fontWeight
                                      : ''
                                  }}
                                  variant="caption"
                                >
                                  {row.caption}{' '}
                                </Typography>
                              )}
                            </Grid>
                            {content?.find(
                              item =>
                                item.textType === 'TOOLTIP' &&
                                row.label.includes('Cicilan Per Bulan')
                            ) && (
                              <Grid
                                item
                                style={{
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                {getTooltip()}
                              </Grid>
                            )}
                          </Grid>
                        </TableCell>
                        <TableCell align="left" className={cellClassName}>
                          <Typography
                            style={{
                              color: row.colorText ? row.colorText : '',
                              fontWeight: row.fontWeight ? row.fontWeight : ''
                            }}
                            variant="body1"
                          >
                            {row.value}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      );
    } else {
      return (
        <div
          className={isNewStyleDoc(docType) ? classes.bodyRiplay : classes.body}
          style={{ overflow: 'auto' }}
        >
          {item.table.rows.map(row => (
            <p key={row.label}>
              {row.label} : {row.value}
            </p>
          ))}
        </div>
      );
    }
  };

  const getInfoPayment = item => {
    const dataPayment = item.paymentContent;
    return (
      dataPayment && (
        <Box className={classes.boxInfoPayment}>
          <Grid container direction="column" spacing={2}>
            <Grid container direction="column" item>
              <Typography color="textSecondary" variant="body1">
                Total tagihan
              </Typography>
              <Typography className={classes.textTotalPayment} variant="h3">
                {dataPayment.totalOutstanding}
              </Typography>
            </Grid>
            <Grid container direction="row" justifyContent="space-between" item>
              <Grid item>
                <Typography color="textSecondary" variant="body1">
                  Rekening Pembayaran
                </Typography>
                <Typography style={{ fontWeight: '700' }} variant="body1">
                  {dataPayment.nameAccount}
                </Typography>
                <Typography style={{ fontWeight: '700' }} variant="body1">
                  {dataPayment.bankAccount === '002' ? 'Bank BRI' : 'Bank Raya'}{' '}
                  • {dataPayment.paymentAccount}
                </Typography>
              </Grid>
              <Grid item>
                <img
                  alt="icon"
                  src={
                    dataPayment.bankAccount === '002'
                      ? '/images/assets/new-bri-icon.svg'
                      : '/images/assets/new-raya-icon.svg'
                  }
                />
              </Grid>
            </Grid>
            <Grid item>
              <Divider />
            </Grid>
            <Grid item>
              <Typography color="textSecondary" variant="body1">
                {dataPayment.textNote}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )
    );
  };

  const getList = item => {
    return (
      <>
        {item.text && (
          <p
            className={
              isNewStyleDoc(docType) ? classes.subTitleRiplay : classes.subTitle
            }
            style={{
              marginLeft: item.indentLevel + 'vh',
              marginTop: '16px'
            }}
          >
            {item.srlNumber !== 'NULL' && <b>{item.srlNumber}. </b>}
            {item.text}
          </p>
        )}

        <List>
          {item.list.contents.map(temp => (
            <ListItem
              key={temp.text}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                padding: '0px'
              }}
            >
              <ListItemIcon
                style={{
                  paddingTop: '4px',
                  minWidth: 'auto',
                  marginRight: '8px'
                }}
              >
                <FiberManualRecordIcon
                  fontSize="small"
                  style={{ color: item.list.color, width: '8px' }}
                />
              </ListItemIcon>
              <ListItemText primary={temp.text} />
            </ListItem>
          ))}
        </List>
      </>
    );
  };

  const getContents = () => {
    if (content?.find(item => item.displayOrder)) {
      return Object.keys(content).map(index => (
        <Grid container direction="row" key={index}>
          <Grid
            className={
              isNewStyleDoc(docType) ? classes.subTitleRiplay : classes.subTitle
            }
            item
          >
            {content[index].textName}
          </Grid>
          <Grid
            className={
              isNewStyleDoc(docType) ? classes.bodyRiplay : classes.body
            }
            item
          >
            {content[index].textDescription}
          </Grid>
        </Grid>
      ));
    } else if (content?.find(item => item.textName)) {
      return (
        <>
          {content.map(item => (
            <div id="doc" key={item.textName}>
              {item.textType === 'HEADER' && (
                <p
                  className={
                    isNewStyleDoc(docType)
                      ? classes.subTitleRiplay
                      : classes.subTitle
                  }
                  style={{ marginLeft: item.indentLevel + 'vh' }}
                >
                  {item.srlNumber !== 'NULL' && <b>{item.srlNumber}. </b>}
                  {item.text}
                </p>
              )}
              {item.textType === 'TEXT' && (
                <p
                  className={
                    isNewStyleDoc(docType) ? classes.bodyRiplay : classes.body
                  }
                  style={{ marginLeft: item.indentLevel + 'vh' }}
                >
                  {item.srlNumber !== 'NULL' && <b>{item.srlNumber}. </b>}
                  {ReactHtmlParser(item.text)}
                </p>
              )}
              {item.textType === 'INFO_PAYMENT' && getInfoPayment(item)}
              {item.textType === 'TABLE' && getTextTable(item)}
              {item.textType === 'LIST' && getList(item)}
            </div>
          ))}
        </>
      );
    } else {
      setError('system');
    }
  };

  return <>{getContents()}</>;
};

ContentDocument.propTypes = {
  classes: PropTypes.shape({
    bodyRiplay: PropTypes.string,
    body: PropTypes.string,
    boxInfoPayment: PropTypes.string,
    textTotalPayment: PropTypes.string,
    subTitle: PropTypes.string,
    subTitleRiplay: PropTypes.string,
    tableCellOutlined: PropTypes.string,
    tableCellNoOutlined: PropTypes.string,
    tableCell: PropTypes.string,
    tableContainer: PropTypes.string,
    titleTableBold: PropTypes.string,
    titleTable: PropTypes.string
  }),
  docType: PropTypes.string,
  setError: PropTypes.func,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      displayOrder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      textName: PropTypes.string,
      textDescription: PropTypes.string,
      textType: PropTypes.string,
      text: PropTypes.string,
      indentLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      srlNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

      table: PropTypes.shape({
        style: PropTypes.string,
        title: PropTypes.shape({
          text: PropTypes.string,
          color: PropTypes.string,
          colorText: PropTypes.string
        }),
        rows: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            caption: PropTypes.string,
            color: PropTypes.string,
            colorText: PropTypes.string,
            fontWeight: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.number
            ])
          })
        )
      })
    })
  )
};

export default withStyles(styles)(ContentDocument);
